import { render, staticRenderFns } from "./UserChoose.vue?vue&type=template&id=458d43e9&scoped=true"
import script from "./UserChoose.vue?vue&type=script&lang=js"
export * from "./UserChoose.vue?vue&type=script&lang=js"
import style0 from "./UserChoose.vue?vue&type=style&index=0&id=458d43e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458d43e9",
  null
  
)

export default component.exports